import { darkModalOutline } from "Styles/darkModal";

import styled from "styled-components";
import media from "styled-media-query";

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 1000;

  background-color: ${({ theme }) => theme.colors.primary.BG};
`;

export const Modal = styled.div`
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.primary.BG};

  position: absolute;
  top: 55px;
  right: ${({ isAdmin }) => (isAdmin ? "200px" : "400px")};
  z-index: 10;

  display: flex;
  flex-direction: column;
  gap: 15px;

  border-radius: 10px;

  ${media.lessThan("medium")`
    width: 100%;
    height: calc(-50px + 100vh);

    position: fixed;
    top: 50px;
    right: 0;
    left: 0;
    bottom: 0;

    border-radius: 0;
  `}

  /* Contorno: sem ele o modal se funde ao fundo preto da pagina. */
  ${darkModalOutline}
`;

export const Notifications = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  button {
    margin: 20px;
  }
`;

export const NoNotifications = styled.span`
  font-size: 16px;
  padding: 0px 20px 20px 20px;
`;

export const NotificationScroll = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding-top: 20px;

  ${media.lessThan("medium")`
    max-height: calc(100vh - 130px);
    padding-bottom: 84px;
  `}
`;

export const Title = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 20px 10px 20px;

  background-color: ${({ theme }) => theme.colors.primary.BG};

  h1 {
    font-size: 18px;
    color: ${({ theme, isAdmin }) =>
      isAdmin
        ? theme.colors.primary.vividCerulean
        : theme.colors.neutral.white};
    font-weight: 700;

    text-align: center;
  }

  span {
    cursor: pointer;

    position: absolute;
    right: 20px;
    top: 20px;
  }
`;

export const NotificationWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;

  height: 100%;

  background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Buttons = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

/*
 * Item de ALERTA (parte 4). Diferente do antigo `Notification`: não tem ícone
 * de tipo, "NOVA" nem "Marcar como lida" — alerta é estado computado, não
 * mensagem. Só o título e, quando há link, o cursor de clique.
 */
export const Alert = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  padding: 12px 20px;

  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};

  h3 {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary.blue};
  }

  &:hover {
    background-color: ${({ $clickable, theme }) =>
      $clickable ? theme.colors.neutral.cinza100 : "transparent"};
  }
`;
